(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-banner-slider"] && !Shopify.designMode) return;
  try {
    
  (function(){
  var root = document.querySelector('.multi-banner-slider');
  if(!root) return;

  var wrapper = root.querySelector('.mbs-wrapper');
  var slidesContainer = wrapper.querySelector('.mbs-slides');
  var slides = Array.from(wrapper.querySelectorAll('.mbs-slide'));
  var prevBtn = wrapper.querySelector('.mbs-prev');
  var nextBtn = wrapper.querySelector('.mbs-next');
  var dotsWrap = wrapper.querySelector('.mbs-dots');
  var autoplay = wrapper.dataset.autoplay === 'true';
  var autoplayDelay = parseInt('{{ section.settings.autoplay_delay | default: 4000 }}',10) || 4000;
  var current = 0;
  var timer = null;
  var slideCount = slides.length;
  if(slideCount === 0) return;

  // Set height according to section settings
  function computeHeight(){
    var mode = "{{ section.settings.height_mode }}";
    var value = "auto";
    if(mode === 'fixed') value = "{{ section.settings.fixed_px }}";
    else if(mode === 'vh') value = "{{ section.settings.vh_value }}";
    else if(mode === 'custom') value = "{{ section.settings.custom_height }}";
    wrapper.style.height = value;
  }
  computeHeight();

  // Set each slide width to match wrapper
  function setSlideWidths(){
    var w = wrapper.offsetWidth;
    slides.forEach(function(s){ s.style.width = w + 'px'; });
  }
  setSlideWidths();
  window.addEventListener('resize', function(){ setSlideWidths(); computeHeight(); });

  // Build dots
  slides.forEach(function(_, i){
    var dot = document.createElement('button');
    dot.className = 'mbs-dot' + (i===0 ? ' active' : '');
    dot.setAttribute('data-index', i);
    dot.setAttribute('aria-label', 'Go to slide ' + (i+1));
    dotsWrap.appendChild(dot);
    dot.addEventListener('click', function(e){
      current = parseInt(e.currentTarget.getAttribute('data-index'),10);
      update();
      resetAutoplay();
    });
  });

  function update(){
    slidesContainer.style.transform = 'translateX(' + (-current * wrapper.offsetWidth) + 'px)';
    Array.from(dotsWrap.children).forEach(function(d,i){ d.classList.toggle('active', i===current); });
  }

  function prev(){ current = (current - 1 + slideCount) % slideCount; update(); resetAutoplay(); }
  function next(){ current = (current + 1) % slideCount; update(); resetAutoplay(); }

  prevBtn.addEventListener('click', prev);
  nextBtn.addEventListener('click', next);

  // Click whole slide to navigate if link
  slides.forEach(function(s){
    s.addEventListener('click', function(){
      var link = s.getAttribute('data-link');
      if(link && link !== 'null' && link !== '') window.location.href = link;
      else next();
    });
  });

  // Autoplay
  function startAutoplay(){
    if(!autoplay) return;
    stopAutoplay();
    timer = setInterval(next, autoplayDelay);
  }
  function stopAutoplay(){ if(timer){ clearInterval(timer); timer=null; } }
  function resetAutoplay(){ stopAutoplay(); startAutoplay(); }

  wrapper.addEventListener('mouseenter', stopAutoplay);
  wrapper.addEventListener('mouseleave', startAutoplay);

  // Keyboard
  wrapper.setAttribute('tabindex','0');
  wrapper.addEventListener('keydown', function(e){
    if(e.key==='ArrowLeft') prev();
    if(e.key==='ArrowRight') next();
  });

  // Initialize
  update();
  startAutoplay();
})();

  } catch(e) { console.error(e); }
})();
})();
